import { Action, Dispatch } from 'redux';
import { createAction } from "@reduxjs/toolkit";

// --------------------- xcaliber load --------------------- //

import { fetchXCaliberToken } from '../core/amplify/xcaliber/token-fetch';
import { Launch } from './action-types';

const xcaliberTokenAvailable = createAction<CMxAPI.XCaliberTokenResponse>(Launch.XCALIBER_TOKEN);

/**
 * Load XCaliber in a separate thread.
 */
const loadXCaliber = async (dispatch: Dispatch<Action>) => {
  try {
    const tokenResponse: CMxAPI.XCaliberTokenResponse = await fetchXCaliberToken();
    return dispatch(xcaliberTokenAvailable(tokenResponse));
  } catch (e) {
    // FOR AMP-959 construct a failure response
    // so that we can continue with application launch
    return dispatch(
      xcaliberTokenAvailable({
        status: 'FAILED',
        token: '',
        tenantPath: ''
      })
    );
  }
};
export { xcaliberTokenAvailable, loadXCaliber };
